var map = {
	"./Logo-mtg.png": "a3e8",
	"./MTG-Logo.jpg": "3b77",
	"./NoProfile.jpg": "a823",
	"./ambulance-icon.png": "db24",
	"./ambulance-icon2.png": "9c58",
	"./apiIntegration.png": "d54d",
	"./arrowLeft.png": "98f9",
	"./arrowRight.png": "3a52",
	"./bell.png": "1816",
	"./calendar-mini.png": "7dba",
	"./calendar.png": "10b5",
	"./car.png": "1437",
	"./dashlogo.png": "a2bf",
	"./get-started.png": "aab7",
	"./green-car.png": "75bf",
	"./home-icon.png": "cae6",
	"./hospital-icon.png": "f4b3",
	"./loader_download.gif": "f4cc",
	"./loading.gif": "12ae",
	"./markImg.png": "f74d",
	"./menuIcon.png": "2805",
	"./menuNew.jpg": "6933",
	"./mob-bottom2.png": "05fd",
	"./no-data.gif": "376f",
	"./noProfileImage.png": "bd0c",
	"./noresult.png": "8738",
	"./notification.png": "b22a",
	"./patient-icon.png": "b928",
	"./pharmacy-icon.png": "3395",
	"./red-car.png": "f1b5",
	"./search.png": "1b61",
	"./searchIcon.png": "a711",
	"./setting.png": "abf7",
	"./signup-bg1.png": "4956",
	"./signup-bg2.png": "ac8a",
	"./signup-bg3.png": "45f6",
	"./signup-bg4.png": "34eb",
	"./signup-bg5.png": "0be9",
	"./signup-bg6.png": "f6ba",
	"./stop.png": "7e25",
	"./translator.png": "4fee",
	"./transportaion.png": "8b16",
	"./userPic.png": "bba3",
	"./yellow-car.png": "ad5a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";